import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { Utils } from 'src/app/services/utils';
import { UserServices } from 'src/app/services/user.service';
import { AdminService } from 'src/app/services/admin.service';
import { MatPaginator, MatTableDataSource } from '@angular/material';
import { Observable } from 'rxjs';

@Component({
  selector: 'admin-subs',
  templateUrl: './admin-subs.html',
  styleUrls: ['./admin-subs.scss'],
})

export class AdminSubsComponent implements OnInit{

    @Input('load') lazyLoad: Observable<String>;
    loaded: boolean;

    @ViewChild('subsPag') subsPag: MatPaginator;
    subs: MatTableDataSource<any>;
    subsColumns = ['id', 'last_paid', 'date', 'order', 'buyer', 'profiles', 'rw_monthly', 'rw_published', 'rw_total', 'status', 'actions'];
    sub_status;
    
    subs_bulk;
    
    billing_stats: any = {};
    
    public formatNumber;
    
    //Pagination
    public loading;
    public totalItems = 0;
    public page = 0;
    public size = 10;

    //Filter
    public filter: any = {};
    private default_filter = { status: 'any', search: '' };

    constructor( 
        private _admin: AdminService,
        private _utils: Utils, 
    ) {
        this.sub_status = _utils.sub_status;
        this.formatNumber = _utils.formatNumber;
    }
    
    ngOnInit(){

        //Load Subs
        this.lazyLoad.subscribe((tabName)=>{
            Object.assign(this.filter, this.default_filter);
            if(tabName == 'sub' && !this.loaded){
                this.loaded = true;
                this.loadSubs();
                this._getSubStats();
            }
        });

    }

    public loadSubs(sameQuery = false){

        if(!sameQuery) this.page = 0;

        this.loading = true;

        let query = this._parseFilter();

        this._admin.getSubsPag(this.size, this.page, {
            query: query
        }).toPromise()
        .then(result =>{
            let subs = result['subs'];
            subs.forEach(sub => sub.user = sub.buyer_id);
            this._loadTable(subs, result['total']);
            this.loading = false;
        })
        .catch(error =>{
            console.log(error);
            this._utils.showError("Error al cargar reseñas", 3000);
        })

    }

    private _loadTable(subs, total){

        let placeholder = new Array(total)

        const startItem = this.page * this.size;
        for(let i=0; i<this.size; i++){
            if(startItem + i < total) placeholder[startItem + i] = subs[i];
        }

        this.subs = new MatTableDataSource(placeholder);
        this.subs.paginator = this.subsPag;

    }

    private _parseFilter(){
    
        let query = {};

        if(this.filter.status != 'any') query['status'] = this.filter.status;
        if(this.filter.search){
            
            const num = Number.parseInt(this.filter.search)? Number.parseInt(this.filter.search) : -1;
            const regex = { $regex: this.filter.search, $options: 'i' }

            let search = { $or:[

                //IDs
                { _id: num },
                { buyer_id: num },
                { order_id: num },
                { service_id: num },
                { 'profiles._id': num },

                //Texts
                { 'profiles.name': regex }

            ]}

            query = { $and: [query, search] };

        }

        return query;
    
    }

    pageEvent(event){

        this.page = event.pageIndex;
        this.size = event.pageSize;

        this.loadSubs(true);

    }

    /*
    |--------------------------------------------------------------------------
    | ACTIONS
    |--------------------------------------------------------------------------
    */

    changeSubStatus(sub, status){
        this._admin.updateSub(sub._id, status).toPromise()
        .then(response=>{
            this._utils.showSuccess("Subscripción actualizada correctamente.", 5000);
            this.loadSubs();
        })
        .catch(error=>{
            console.log(error);
            this._utils.showError("Error al actualizar sub", 3000);
        })
    }
    
    renewSub(sub){
        this._admin.renewSub(sub._id).toPromise()
        .then(response=>{
            this._utils.showSuccess("Subscripción renovada correctamente.", 5000);
            this.loadSubs();
        })
        .catch(error=>{
            console.log(error);
            this._utils.showError("Error al renovar sub", 3000);
        })
    }

    downloadBill(sub){
        this._admin.billSub(sub._id).toPromise()
        .then(response =>{
            sub.billed = true;
        })
        .catch(error =>{
            console.log(error);
            this._utils.showError("Error al actualizar pedido", 3000);
        })
    }

    public sendInvoiceEmail(sub){

        this._admin.sendInvoiceEmail(sub.order_id)
        .then( res => {
            this._utils.showSuccess("Envío realizado");
            sub.invoice_sent = true; 
        })
        .catch(error => {
            console.log(error)
            this._utils.showError("Error al enviar la factura")
        })

    }

    getBilling(user){

        return `${user.cif}
        ${user.billName}
        ${user.address}
        ${user.cp} ${user.city}
        ${user.country}`

    }

    public downloadInvoice(order_id){

        document.body.style.cursor = 'progress';

        this._admin.getInvoicePDF(order_id)
        .then( (res: any) =>{
            const fileURL = URL.createObjectURL(res);
            window.open(fileURL, '_blank');
        })
        .catch(error => {
            console.log(error)
            this._utils.showError("No es posible descargar esta factura")
        })
        .finally(()=>{
            document.body.style.cursor = 'default';
        })

    }

    _getSubStats(){

        this._admin.getSubStats()
        .then( (res: any) => {

            const last_month = res.last_month;
            const last_year = res.last_year;
            
            this.billing_stats = res.stats;

            this.billing_stats.last_month = {
                total: this.billing_stats.total - last_month.total,
                rw_monthly: this.billing_stats.rw_monthly - last_month.rw_monthly,
                first_period: this.billing_stats.first_period - last_month.first_period,
                price: this.billing_stats.price - last_month.price,
                paypal: this.billing_stats.paypal - last_month.paypal,
                stripe: this.billing_stats.stripe - last_month.stripe,
                sepa: this.billing_stats.sepa - last_month.sepa,
                sepa_price: this.billing_stats.sepa_price - last_month.sepa_price,
                sub_price: this.billing_stats.sub_price - last_month.sub_price
            }

            this.billing_stats.last_year = {
                total: this.billing_stats.total - last_year.total,
                rw_monthly: this.billing_stats.rw_monthly - last_year.rw_monthly,
                first_period: this.billing_stats.first_period - last_year.first_period,
                price: this.billing_stats.price - last_year.price,
                paypal: this.billing_stats.paypal - last_year.paypal,
                stripe: this.billing_stats.stripe - last_year.stripe,
                sepa: this.billing_stats.sepa - last_year.sepa,
                sepa_price: this.billing_stats.sepa_price - last_year.sepa_price,
                sub_price: this.billing_stats.sub_price - last_year.sub_price
            }

        })
        .catch( error => {
            console.log(error)
            this._utils.showError("Error al obtener estadísticas de facturación")
        })

    }

}
